/* src/app/components/doc-viewer-new/dialogs/doc-viewer-settings-dialog/doc-viewer-settings-dialog.component.scss */
[dialog-body] {
  color: var(--text-color);
}
:host-context(.dark-theme) [dialog-body] {
  color: var(--text-color);
}
/*# sourceMappingURL=doc-viewer-settings-dialog.component.css.map */
